import type React from 'react';

interface DataLoadingSpinnerProps {
    text?: string;
}

export const DataLoadingSpinner: React.FC<DataLoadingSpinnerProps> = ({ text = 'Loading data...' }) => {
    return (
        <div className="text-center py-5">
            <div
                className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"
                role="status"
            >
                <span className="sr-only">Loading...</span>
            </div>
            <div className="mt-3">{text}</div>
        </div>
    );
};
